"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CroupierRevealAction = void 0;
const logic_types_1 = require("../logic-types");
class CroupierRevealAction {
    get cardIndex() {
        var _a;
        return (_a = this.card) === null || _a === void 0 ? void 0 : _a.index;
    }
    get cardId() {
        var _a;
        return (_a = this.card) === null || _a === void 0 ? void 0 : _a.cardId;
    }
    constructor(board) {
        this.board = board;
    }
    execute() {
        if (!this.board.croupier.hasCards) {
            throw new Error("No croupier cards to reveal");
        }
        this.card = this.board.croupier.lastCard;
        if (this.card === undefined) {
            throw new Error("Invalid final deck card");
        }
        this.card.setStatusWhenPendingHidden(logic_types_1.CardDisclosureStatus.Pending);
    }
    resolve() {
        var _a;
        (_a = this.card) === null || _a === void 0 ? void 0 : _a.openCard();
    }
    static isAction(action) {
        return action instanceof CroupierRevealAction;
    }
}
exports.CroupierRevealAction = CroupierRevealAction;
